import { getRecipient } from 'Api/beRecipientApi'

import {
  deleteRecipientEventsBounces,
  getRecipientEventsBounces,
} from 'Api/beStatisticsApi'

import { fromUTCtoZoneFormatted, storeGet } from 'mailup-react-helpers'

import { STORE_KEY_ID_LIST, STORE_KEY_LIST } from 'mailup-react-helpers'

export async function getRecipientAction(idRecipient) {
  const resp = await getRecipient(idRecipient)
  return resp
}

export async function getRecipientEventsBouncesAction(
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const resp = await getRecipientEventsBounces(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )

  if (resp.Bounces.EventList) {
    resp.Bounces.EventList.forEach((i, key) => {
      i.FakeId =
        i.BounceType +
        '|' +
        i.IdMessage +
        '|' +
        i.IdSending +
        '|' +
        i.BounceDate

      if (i.EventDate) {
        const date = new Date(i.EventDate)
        i.EventDate = fromUTCtoZoneFormatted(
          date,
          TimeZoneCode,
          'YYYY-MM-DD HH:mm',
        )
      }
    })
  }

  return resp
}

export async function deleteRecipientEventsBouncesAction(
  idRecipient,
  bouncesList,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const resp = await deleteRecipientEventsBounces(
    idList,
    idRecipient,
    bouncesList,
  )
  return resp
}
